export default {
    state: {
        isShowGlobalSearch: false,

        currentFileID: null,
        currentAssetType: null,
        currentProvider: null,
        currentGame: null,
        currentFileStatus: null,
        currentAdditionalStatus: null,
        // Only files where the folder and the model disagreed on the asset type.
        currentDisputed: false,
        // Server page of the disputes list (0-based). Only that list is paged
        // on the server: it is the one that outgrows the listing cap.
        currentPage: 0,

        selectFilter: [],
        selestTag: [],
    },
    getters: {
        IS_SHOW_GLOBAL_SEARCH: state => { return state.isShowGlobalSearch },

        CURRENT_FILE_ID: state => { return state.currentFileID },
        CURRENT_ASSET_TYPE: state => { return state.currentAssetType },
        CURRENT_PROVIDER: state => { return state.currentProvider },
        CURRENT_GAME: state => { return state.currentGame },
        CURRENT_FILE_STATUS: state => { return state.currentFileStatus },
        CURRENT_ADDITIONAL_STATUS: state => { return state.currentAdditionalStatus },
        CURRENT_DISPUTED: state => { return state.currentDisputed },
        CURRENT_PAGE: state => { return state.currentPage },

        SELECT_FILTER: state => { return state.selectFilter },
        SELECT_TAG: state => { return state.selestTag },
    },
    mutations: {
        IS_SHOW_GLOBAL_SEARCH: (state, payload) => { state.isShowGlobalSearch = payload },

        CURRENT_FILE_ID: (state, payload) => { state.currentFileID = payload },
        CURRENT_ASSET_TYPE: (state, payload) => { state.currentAssetType = payload },
        CURRENT_PROVIDER: (state, payload) => { state.currentProvider = payload },
        CURRENT_GAME: (state, payload) => { state.currentGame = payload },
        CURRENT_FILE_STATUS: (state, payload) => { state.currentFileStatus = payload },
        CURRENT_ADDITIONAL_STATUS: (state, payload) => { state.currentAdditionalStatus = payload },
        CURRENT_DISPUTED: (state, payload) => { state.currentDisputed = payload },
        CURRENT_PAGE: (state, payload) => { state.currentPage = Math.max(0, Number(payload) || 0) },

        SELECT_FILTER: (state, payload) => { state.selectFilter = payload },
        SELECT_TAG: (state, payload) => { state.selestTag = payload },
    },
    actions: {
        SET_PARAMS_IN_QUERY: async function (context, query) {
            context.commit('CURRENT_FILE_ID',
                query.fileID == null ? null : Number(query.fileID)
            );
            context.commit('CURRENT_ASSET_TYPE',
                query.assetTypeID == null ? 'all' : Number(query.assetTypeID)
            );
            context.commit('CURRENT_PROVIDER',
                query.providerID == null ? 'all' : Number(query.providerID)
            );
            context.commit('CURRENT_GAME',
                query.gameID == null ? 'all' : Number(query.gameID)
            );
            context.commit('CURRENT_FILE_STATUS',
                query.fileStatus == null ? 'all' : query.fileStatus
            );
            context.commit('CURRENT_ADDITIONAL_STATUS',
                query.additionalStatus == null ? 'all' : query.additionalStatus
            );
            context.commit('CURRENT_DISPUTED', query.disputed === 'true' || query.disputed === true);
            context.commit('CURRENT_PAGE', query.page == null ? 0 : Number(query.page));


            if (query.filter == null) context.commit('SELECT_FILTER', []);
            else context.commit('SELECT_FILTER', structuredClone(query.filter));

            if (query.tag == null) context.commit('SELECT_TAG', []);
            else {
                let selectTag = query.tag;
                if (typeof selectTag === 'string') selectTag = [selectTag];
                selectTag.forEach((tagValue, tagIndex) => {
                    selectTag[tagIndex] = Number(tagValue);
                });
                context.commit('SELECT_TAG', structuredClone(selectTag));
            }
        },

        RESET_PARAMS: async function (context) {
            context.commit('CURRENT_ASSET_TYPE', context.getters.ASSET_TYPE_IMAGES);
            context.commit('CURRENT_GAME', context.getters.DEFAULT_GAME);
            context.commit('CURRENT_PROVIDER', context.getters.DEFAULT_PROVIDER);
            context.commit('CURRENT_FILE_STATUS', context.getters.DEFAULT_FILE_STATUS);
            context.commit('CURRENT_ADDITIONAL_STATUS', context.getters.DEFAULT_ADDITIONAL_STATUS);
            context.commit('CURRENT_DISPUTED', false);
            context.commit('CURRENT_PAGE', 0);
            context.commit('SELECT_FILTER', []);
            context.commit('SELECT_TAG', []);
        }
    }
}